import ChangeStoreSideMenu from "JS/components/side-menus/change-store/ChangeStoreSideMenu.vue";
import Vue from "vue";
import { ChangeStoreVariant } from "JS/components/side-menus/change-store/change-store-types";

export function initializeChangeStoreButton(selector: string, menuVariant: ChangeStoreVariant): void {
	const changeStoreButton = document.querySelector<HTMLButtonElement>(selector);
	if (changeStoreButton) {
		const sideMenu = new Vue({ extends: ChangeStoreSideMenu, propsData: { show: false, variant: menuVariant } });

		sideMenu.$mount(document.createElement('div'));
		document.body.appendChild(sideMenu.$el);

		changeStoreButton.addEventListener('click', _e => {
			sideMenu.$props.show = true;
		});

		sideMenu.$on('close', () => {
			sideMenu.$props.show = false;
		});
	}
}